import http from '../../src/api/axiosConfig'

class ManageUsers {

    prefix = '/v1/web/user/'

    loadUsers() {
        return http.get(this.prefix+'all')
    }

    addUser(data) {
        console.log(data)
        return http.post('/auth/register-with-number',data)
    }

    activateOrDesactivateUser(data) {
        console.log(data)
        return http.put(this.prefix+'activation',data)
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ManageUsers()